'use client';

import { useEffect, useRef } from 'react';
import { useChatStore } from '@/stores/chatStore';
import ChatMessage from './ChatMessage';
import ChatInput from './ChatInput';
import { MessageCircle } from 'lucide-react';

export default function ChatInterface() {
  const { messages, isStreaming, sendMessage } = useChatStore();
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <div className="flex flex-col h-full">
      {/* Message area */}
      <div ref={scrollRef} className="flex-1 overflow-y-auto px-6 py-4">
        {messages.length === 0 ? (
          <div className="flex flex-col items-center justify-center h-full gap-4 opacity-40">
            <MessageCircle size={48} style={{ color: 'var(--accent-gold)' }} />
            <p className="text-sm" style={{ color: 'var(--text-secondary)' }}>
              Ask any question about the Bible
            </p>
          </div>
        ) : (
          messages.map((msg, i) => (
            <ChatMessage
              key={msg.id}
              message={msg}
              isStreaming={
                isStreaming &&
                i === messages.length - 1 &&
                msg.role === 'assistant'
              }
            />
          ))
        )}
      </div>

      {/* Input area */}
      <div className="px-6 pb-4">
        <ChatInput onSend={sendMessage} disabled={isStreaming} />
      </div>
    </div>
  );
}
